
import Highlight from '../../../components/base/Highlight';

export default function ConclusionCard() {
  return (
    <section className="py-16 bg-gradient-to-br from-teal-50 via-emerald-50 to-white">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 border-t-8 border-teal-500">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-full mb-6 shadow-lg">
              <i className="ri-shield-check-line text-4xl text-white"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              結論：<Highlight variant="marker" color="red">DMM FXは安全です</Highlight>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              金融庁の厳しい審査をクリアし、全額信託保全で資産を守る体制が整っています。
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-government-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">金融庁登録済み</h3>
              <p className="text-sm text-gray-600">
                関東財務局長（金商）第1629号
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-6 text-center">
              <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">全額信託保全</h3>
              <p className="text-sm text-gray-600">
                顧客資産は完全に分別管理
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl p-6 text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">24時間サポート</h3>
              <p className="text-sm text-gray-600">
                HDI格付け三つ星獲得
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-500 to-emerald-600 rounded-xl p-6 text-white">
            <div className="flex items-start gap-4">
              <i className="ri-information-line text-3xl flex-shrink-0 mt-1"></i>
              <div>
                <h3 className="font-bold text-lg mb-2">安全性の根拠</h3>
                <p className="text-sm text-teal-50 leading-relaxed">
                  DMM FXは金融庁の厳格な監督下にあり、法令遵守を徹底しています。また、顧客の資産は信託銀行で分別管理されており、万が一DMM.com証券が破綻しても全額保護されます。さらに、業界トップクラスのサポート体制で初心者も安心して取引できます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
